<template>
  <div class="container">
    <button class="button is-primary is-small is-pulled-right" @click="add">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Cadastrar</span>
    </button>
    <br><br>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar</p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraGraficoIndicador && !mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição" v-model="grafico.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Tipo</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="grafico.tipo">
                      <option value="0" disabled>Selecione um tipo de gráfico</option>
                      <option value="1">Pizza</option>
                      <option value="2">Barras</option>
                      <option value="3">Linhas</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Versão</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="graficoCompartilhar.versao_plano_contas">
                        <option v-for="versao_plano_contas in versoesPlanoContas" :key="versao_plano_contas.id" :value="versao_plano_contas">
                          {{ versao_plano_contas.descricao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraGraficoIndicador">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Grupo de Indicador</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="cmbGrupoIndicador" @change="selectGrupoIndicador">
                        <option value="0">Todos os grupos de indicadores</option>
                        <option v-for="gi in gruposIndicadores" :key="gi.id" :value="gi.id">
                          {{ gi.descricao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Indicador</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="graficoIndicador.indicador">
                        <option value="0" disabled>Selecione um indicador</option>
                        <option v-for="indicador in indicadores" :key="indicador.id" :value="indicador">
                          {{ indicador.descricao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Salvar</button>
          <button class="button" v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns">
      <div class="column is-5">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">Gráficos</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th>Tipo</th>
                    <th class="has-text-centered">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(grafico, index) in graficos" :key="grafico.id">
                    <td>{{ grafico.descricao }}</td>
                    <td>{{ grafico.tipo === '1' ? 'Pizza' : grafico.tipo === '2' ? 'Barras' : 'Linhas' }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" :disabled="mostraCompartilhamento || mostraGraficoIndicador" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" :disabled="mostraCompartilhamento || mostraGraficoIndicador" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-primary is-outlined" @click="callCompartilhamento(grafico)" :disabled="mostraCompartilhamento || mostraGraficoIndicador" title="Compartilhar">
                          <span class="icon is-small">
                            <i class="fas fa-share-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="callGraficoIndicador(grafico)" :disabled="mostraCompartilhamento || mostraGraficoIndicador" title="Configurar Indicadores">
                          <span class="icon is-small">
                            <i class="fas fa-th-list"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraCompartilhamento">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Compartilhar {{ graficoSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraCompartilhamento = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Versão</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(gv, index) in graficoVersoes" :key="gv.id">
                    <td>{{ gv.versao_plano_contas.descricao }}</td>
                    <td class="has-text-centered">
                      <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraCompartilhamento = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>

      <div class="column" v-show="mostraGraficoIndicador">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Indicadores do Gráfico {{ graficoSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraGraficoIndicador = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Indicador</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(gi, index) in graficoIndicadores" :key="gi.id">
                    <td>{{ gi.indicador.descricao }}</td>
                    <td class="has-text-centered">
                      <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraGraficoIndicador = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {http} from '../../services/config'

    export default {
        name: "Grafico",

        data(){
            return{
                grafico: {
                    id: null,
                    descricao: null,
                    tipo: "0",
                    usuario: null
                },
                graficoIndicador: { id: null,
                    grafico: null,
                    indicador: "0"
                },
                graficoCompartilhar: { id: null,
                    grafico: null,
                    versao_plano_contas: null
                },
                graficos: [],
                graficoIndicadores: [],
                graficoVersoes: [],
                indicadores: [],
                versoesPlanoContas: [],
                cmbGrupoIndicador: "0",
                isShowModal: false,
                mostraGraficoIndicador: false,
                mostraCompartilhamento: false,
                graficoSelecionado: {
                    id: null,
                    descricao: null
                },
                previous: null,
                next: null,
                page: null,
                numpages: null
            }
        },

        methods: {
            add: function() {
                this.clearFields()
                this.isShowModal = true   
                this.cmbGrupoIndicador = "0"
                http.get('indicador/listar/', {params: {
                    idGrupoIndicador: "0"
                }}).then(response => {
                    this.indicadores = response.data.results
                })
            },

            edit: function(index){
                if (!this.mostraGraficoIndicador) {
                    this.grafico.id = this.graficos[index].id
                    this.grafico.descricao = this.graficos[index].descricao
                    this.grafico.tipo = this.graficos[index].tipo
                    this.grafico.usuario = this.graficos[index].usuario
                    this.grafico.index = index
                }
                this.isShowModal = true
            },

            selectGrupoIndicador: function() {
                http.get('indicador/listar/', {params: {
                    idGrupoIndicador: this.cmbGrupoIndicador
                }}).then(response => {
                    this.indicadores = response.data.results
                })
            },

            callCompartilhamento: function(graf) {
                this.mostraCompartilhamento = true
                this.graficoSelecionado = graf
                http.get('grafico/listarVersoes/', {params: {
                    idGrafico: this.graficoSelecionado.id
                }}).then(response => {
                    this.graficoVersoes = response.data.results
                })
            },

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {
                    if (!this.mostraGraficoIndicador && !this.mostraCompartilhamento) {
                        http.delete('/grafico/excluir/'+this.graficos[index].id).then(response =>{
                            this.graficos.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    } else if (this.mostraCompartilhamento) {
                        http.delete('/grafico/excluirVersoes/'+this.graficoVersoes[index].id).then(response =>{
                            this.graficoVersoes.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    } else if (this.mostraGraficoIndicador) {
                        http.delete('/graficoIndicador/excluir/'+this.graficoIndicadores[index].id).then(response =>{
                            this.graficoIndicadores.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                }
            },

            callGraficoIndicador: function(grafico) {
                this.mostraGraficoIndicador = true
                this.graficoSelecionado = grafico
                http.get('graficoIndicador/listar/', {params: {
                    idGrafico: this.graficoSelecionado.id
                }}).then(response => {
                    this.graficoIndicadores = response.data.results
                })
            },

            clearFields: function() {
                if (!this.mostraGraficoIndicador && !this.mostraCompartilhamento) {
                    this.grafico = {id: null,
                        descricao: null,
                        tipo: "0",
                        usuario: null,
                        index: null }
                } else if (this.mostraCompartilhamento) {
                    this.graficoCompartilhar = {id: null,
                        grafico: null,
                        versao_plano_contas: null }
                } else if (this.mostraGraficoIndicador) {
                    this.graficoIndicador = {id: null,
                        grafico: null,
                        indicador: "0" 
                    }
                }
            },

            save: function(){
                var data

                if (!this.mostraGraficoIndicador && !this.mostraCompartilhamento) {
                    if (this.grafico.descricao == null || this.grafico.descricao == '') {
                        alert('Descrição não preenchida!')
                        return
                    }

                    if (this.grafico.tipo == null || this.grafico.tipo == "0") {
                        alert('Tipo de gráfico não selecionado!')
                        return
                    }

                    data = {id: this.grafico.id,
                        descricao: this.grafico.descricao,
                        tipo: this.grafico.tipo,
                        usuario: this.$store.state.idUser
                    }

                    let formData = new FormData()

                    formData.append('id', data.id)
                    formData.append('usuario', data.usuario)
                    formData.append('descricao', data.descricao)
                    formData.append('tipo', data.tipo)

                    if (this.grafico.id == null) {
                        http.post('/grafico/adicionar', formData).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.grafico.id = response.data.id
                                this.graficos.push(this.grafico)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                    else {
                        http.put('/grafico/editar/'+this.grafico.id, formData).then(response =>{
                            this.graficos[this.grafico.index].descricao = response.data.descricao
                            this.graficos[this.grafico.index].tipo = this.grafico.tipo
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    }
                } else if (this.mostraCompartilhamento) {
                    if (this.graficoCompartilhar.versao_plano_contas == null) {
                        alert('Versão não informada!')
                        return
                    }

                    data = {id: this.graficoCompartilhar.id,
                        grafico: this.graficoSelecionado.id,
                        versao_plano_contas: this.graficoCompartilhar.versao_plano_contas.id
                    }

                    if (this.graficoCompartilhar.id == null) {
                        http.post('/grafico/adicionarVersoes', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.graficoCompartilhar.id = response.data.id
                                this.graficoVersoes.push(this.graficoCompartilhar)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                }    
                 else if (this.mostraGraficoIndicador) {
                    if (this.graficoIndicador.indicador == null || this.graficoIndicador.indicador == "0") {
                        alert('Indicador não informado!')
                        return
                    }

                    data = {id: this.graficoIndicador.id,
                        grafico: this.graficoSelecionado.id,
                        indicador: this.graficoIndicador.indicador.id
                    }

                    if (this.graficoIndicador.id == null) {
                        http.post('/graficoIndicador/adicionar', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.graficoIndicador.id = response.data.id
                                this.graficoIndicadores.push(this.graficoIndicador)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                }    
            }
        },

        mounted: function() {
        },
        
        created: function() {
            http.get('versoesPlanoContas/listar').then(response => {
                this.versoesPlanoContas = response.data.results
            })

            http.get('grafico/listar/').then(response => {
                this.graficos = response.data.results
            })

            http.get('grupoIndicador/listar/').then(response => {
                this.gruposIndicadores = response.data.results
            })

        }
    }
</script>


<style scoped>
</style>